<template>
  <div
    v-show="show"
    style="
      background-color: rgba(0, 0, 0, 0.3);
      width: 100vw;
      height: 100vh;
      z-index: 2000;
      position: fixed;
      top: 0;
      left: 0;
    "
  >
    <el-dialog title="报名管理" :visible.sync="show" width="50%">
      <div
        style="
          width: 100%;
          height: 60vh;
          overflow-y: auto;
          padding: 20px;
          font-size: 16px;
        "
      >
        <div style="margin-bottom: 10px">
          已报名人数<span style="color: #277bf5">({{ bmList.length }}人)</span>
        </div>

        <div style="width: 100%">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              padding: 10px 0;
              border-bottom: 1px solid #eee;
            "
            v-for="item in bmList"
          >
            <div style="color: #333; font-size: 16px; font-weight: bold">
              {{ item.user.name ? item.user.name : "报名人员" }}
            </div>
            <div style="font-size: 14px; display: flex">
              <div
                style="margin-right: 15px; color: #277bf5; cursor: pointer"
                @click="openqd(item)"
              >
                签到
              </div>
              <span style="margin-right: 10px">报名时间：</span
              ><span style="color: #333">{{ item.join_time }}</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="签到"
      :visible.sync="showqd"
      width="30%"
      :destroy-on-close="true"
      :before-close="closeqd"
    >
      <div
        style="
          width: 100%;
          height: 10vh;
          overflow-y: auto;
          padding: 20px;
          font-size: 16px;
        "
      >
        <el-date-picker
          v-model="sign_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          :append-to-body="false"
        >
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeqd">取 消</el-button>
        <el-button type="primary" @click="qdfun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      id: "",
      bmList: [],
      showqd: false,
      sign_time: "",
      sign_id: "",
    };
  },
  methods: {
    openqd(item) {
      this.showqd = true;
      this.sign_id = item.id;
    },
    qdfun() {
      if (!this.sign_time) {
        this.$message.warning("请先选择时间");
        return;
      }
      this.$post({
        url: "/api/Activity/sign",
        params: {
          id: this.sign_id,
          sign_time: this.sign_time,
        },
      }).then((res) => {
        if (res) {
          this.$message.success("签到成功");
          this.closeqd();
        }
      });
    },
    closeqd() {
      this.showqd = false;
      this.sign_time = "";
      this.sign_id = "";
    },
    getlist() {
      this.$post({
        url: "/api/wymeeting/hyry",
        params: {
          wymeeting_id: this.id,
          type: 3,
        },
      }).then((res) => {
        this.bmList = res.data.list;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
